import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const WorkspaceQuietHours = lazy(() =>
  import("@scenes/WorkspaceQuietHours").then((module) => ({
    default: module.default.WorkspaceQuietHours,
  }))
);

export const appSettingsQuietHoursNRO: NavigationRoutingObject = {
  section: "settings",
  Component: WorkspaceQuietHours,
  heading: (t: I18nT<"dashboard-navigation">) => t("app-settings-workspace-quiet-hours-nro-heading", "Quiet Hours"),
  pageNameForTracking: () => "Workspace Quiet Hours",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermissionForAnyScope }) => {
    if (!featureOn("workspace_quiet_hours")) {
      return false;
    }

    return hasPermissionForAnyScope("viewQuietHoursSettings");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
  componentFeatureFlippers: ["workspace_quiet_hours"],
};
